import { createStore, applyMiddleware } from 'redux';
import rootReducer from '../reducers';
import thunk from 'redux-thunk';

export default function configureStore (initialState) {
  var store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(thunk)
  );

  return store;
};
